// Escape can do a lot of things!

import { appRoutes } from "@/app/router";
import type { Maybe } from "@/domains/common/types";
import type { AppStore } from "@/store";
import type { NotesViewPageStore } from "@/store/pages/NotesViewPageStore/NotesViewPageStore";
import { matchPath } from "react-router";

// Close find-in-note, otherwise close current note tab, otherwise go to notes list.
export const executeEscapeShortcut = ({
  notesViewPageStore,
  store,
}: {
  notesViewPageStore: Maybe<NotesViewPageStore>;
  store: AppStore;
}) => {
  if (!notesViewPageStore) return;

  const tabId = notesViewPageStore.tabId;
  const tab = store.navigation.tabs.tabsMap.get(tabId);

  const noteIdMatch = matchPath(
    appRoutes.notesView({ params: { noteId: ":noteId" }, starPattern: true }),
    tab?.path ?? ""
  );

  if (noteIdMatch) {
    if (notesViewPageStore?.findInNote?.isOpen) {
      notesViewPageStore.findInNote.close();
      return;
    }

    store.navigation.tabs.closeTab({ tabId });
    return;
  }

  store.navigation.tabs.openInNewTab({ path: appRoutes.notesList({}).path });
};
